import { render } from "./ConsultStatusSelector.vue?vue&type=template&id=73111a5c&ts=true"
import script from "./ConsultStatusSelector.vue?vue&type=script&lang=ts"
export * from "./ConsultStatusSelector.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__